import { useEffect, useState } from 'react';
import { filter } from 'lodash';
import { setToastInfo } from '../../../store/common.slice';
import { ToastType } from '../../../types/common.types';
import IconButton, { IconButtonTypes } from '../../common/IconButton';
import { useDispatch } from 'react-redux';
import SearchField from '../../common/SearchField';
import QuizItem from './QuizItem';
import Tooltip from '../../common/Tooltip';
import QuizService from '../../../services/quiz.service';
import { TQuiz } from './types';
import { useNavigate } from 'react-router-dom';

const QuizList = () => {
  const [quizzes, setQuizzes] = useState<TQuiz[]>([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchText, setSearchText] = useState('');

  const getQuizList = async () => {
    try {
      const response = await QuizService.getAllQuizzes();
      if (response.data.data && response.data.data.quizzes) {
        setQuizzes(response.data.data.quizzes);
      } else {
        console.log('Error: ', response.data.message);
      }
    } catch (err) {
      console.log('Error: ', err);
    }
  };

  const deleteQuiz = async (quizId: string) => {
    if (!quizId) return;
    try {
      const deleteResponse = await QuizService.deleteQuiz(quizId);
      if (!deleteResponse.data.error) {
        dispatch(
          setToastInfo({
            isOpen: true,
            message: deleteResponse.data.message,
            type: ToastType.SUCCESS,
          })
        );
        getQuizList();
      } else {
        dispatch(
          setToastInfo({
            isOpen: true,
            message: deleteResponse.data.message,
            type: ToastType.ERROR,
          })
        );
      }
    } catch (err) {
      dispatch(
        setToastInfo({
          isOpen: true,
          message: 'Error in deleting quiz.',
          type: ToastType.ERROR,
        })
      );
    }
  };

  useEffect(() => {
    getQuizList();
  }, []);

  const filteredQuizzes = filter(quizzes, (quiz: TQuiz) =>
    quiz.name.toLowerCase().includes(searchText.toLowerCase())
  );

  return (
    <div className="overflow-y-auto w-full">
      <div className="flex flex-col px-5">
        <h3 className="text-[24px] font-semibold">Quizzes</h3>
        <div className="text-[14px] text-[#666] gap-2 flex mt-1">
          <p className="text-[#64748B]">
            Create and manage quizzes to assess student knowledge across
            different subjects and skills.
          </p>
        </div>

        <div className="flex gap-3 mt-4 items-center">
          <SearchField
            placeholder="Search quizzes by name..."
            onChange={(e) => setSearchText(e.target.value)}
            value={searchText}
          />
          <Tooltip content="Create new quiz">
            <IconButton
              onClick={() => navigate('/quiz/create')}
              color={IconButtonTypes.PRIMARY}
              icon="plus"
              type="button"
              text="Create"
            />
          </Tooltip>
        </div>

        <div className="mt-6 gap-4 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 pb-5">
          {filteredQuizzes.length > 0 ? (
            filteredQuizzes.map((quiz) => (
              <QuizItem
                key={quiz._id}
                quiz={quiz}
                deleteQuiz={deleteQuiz}
              />
            ))
          ) : (
            <div className="col-span-full text-center py-8 text-[#666]">
              No quizzes found
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default QuizList;